import * as tslib_1 from "tslib";
import React, { Suspense, lazy, useState, useEffect } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import LoadingIndicator from '../LoadingIndicator';
var Ad = lazy(function () {
    return import(
    /* webpackChunkName: "dealer" */
    './DealerAd');
});
export var LoadableAdWrapper = function (props) {
    var _a = useState(false), mounted = _a[0], setMounted = _a[1];
    useEffect(function () {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, null) },
            React.createElement(Ad, tslib_1.__assign({}, props)))));
};
LoadableAdWrapper.displayName = 'LoadableAdWrapper';
export default LoadableAdWrapper;
//# sourceMappingURL=LoadableDealerAd.js.map